import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/organization/")({
  beforeLoad: () => {
    throw redirect({ to: "/organization/chart" });
  },
});
